import { OnlineStorage } from "@tblabs/storage";
import { Div, RefString, Select, MultilineInput, Button } from "@tblabs/truffle";


export class LogViewer extends Div
{
    private logSelector = new Select(new RefString(), []).Style("flex: 1;");
    private logOutput = new MultilineInput().Rows(12).Readonly();

    private async LoadLog(): Promise<void>
    {
        if (!this.logSelector.Value)
        {
            this.logOutput.Value = "No log selected";
            return;
        }

        try
        {
            this.logOutput.Value = "Loading log...";
            this.logOutput.Value = await this._storage.GetLog(this.logSelector.Value ?? "");
            this.logOutput.ScrollToBottom();
        }
        catch (ex: any)
        {
            this.logOutput.Value = "Failed to load log: " + ex.message;
        }
    }

    constructor(private _storage: OnlineStorage)
    {
        super();

        this.logSelector
            .OnChange(async () => await this.LoadLog());

        this.Append(
            new Div().Style("display: flex; gap: 8px;").Append(
                this.logSelector,
                new Button("Refresh")
                    .OnClick(async () => await this.LoadLog())
            ).MarginBottom(8),
            this.logOutput,
        );
    }

    async OnAppend(): Promise<void>
    {
        try
        {
            const logs = await this._storage.GetLogsList();

            if (!logs || logs.length === 0)
            {
                this.logOutput.Value = "No logs found";
                return;
            }

            this.logSelector.LoadOptions(logs);
            this.logSelector.Value = logs[logs.length - 1];
        }
        catch (ex: any)
        {
            this.logOutput.Value = "Failed to load logs: " + ex.message;
        }
    }
}
